'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_content_Layer(number, hue, name, role, tools) {
  this.ht = null;
  this.jU = null;
  this.hs = null;
  this.hu = null;
  this.hv = null;
  this.ht = number;
  this.jU = hue;
  this.hs = name;
  this.hu = role;
  this.hv = tools;
}
export { $c_Lio_intela_sites_intelacloud_content_Layer as $c_Lio_intela_sites_intelacloud_content_Layer };
$p = $c_Lio_intela_sites_intelacloud_content_Layer.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_content_Layer;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_content_Layer() {
}
export { $h_Lio_intela_sites_intelacloud_content_Layer as $h_Lio_intela_sites_intelacloud_content_Layer };
$h_Lio_intela_sites_intelacloud_content_Layer.prototype = $p;
$p.O = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.q = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().V(this, (-1160611581), true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_intelacloud_content_Layer)) {
    if ((this.ht === x$0.ht)) {
      var x = this.jU;
      var x$2 = x$0.jU;
      var $x_1 = (x === x$2);
    } else {
      var $x_1 = false;
    }
    if ((($x_1 && (this.hs === x$0.hs)) && (this.hu === x$0.hu))) {
      var x$3 = this.hv;
      var x$4 = x$0.hv;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.r = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().U(this);
});
$p.G = (function() {
  return 5;
});
$p.I = (function() {
  return "Layer";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.ht;
      break;
    }
    case 1: {
      return this.jU;
      break;
    }
    case 2: {
      return this.hs;
      break;
    }
    case 3: {
      return this.hu;
      break;
    }
    case 4: {
      return this.hv;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_intelacloud_content_Layer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bx)));
}
export { $isArrayOf_Lio_intela_sites_intelacloud_content_Layer as $isArrayOf_Lio_intela_sites_intelacloud_content_Layer };
var $d_Lio_intela_sites_intelacloud_content_Layer = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_content_Layer, "io.intela.sites.intelacloud.content.Layer", ({
  bx: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_intelacloud_content_Layer as $d_Lio_intela_sites_intelacloud_content_Layer };
//# sourceMappingURL=io.intela.sites.intelacloud.content.-Layer.js.map
